<div class="database-card">
    <div class="flex justify-content-between gap-2">
        <h2 class="database-card__title">{{ database?.name }}</h2>
        @if (!database?.custom) {
            <span
                class="database-card__lock material-symbols-outlined icon-md"
                [pTooltip]="'emissionFactors.toolTip.defaultDatabase' | translate"
                tooltipPosition="left"
                >lock</span
            >
        }
    </div>
    <span class="database-card__description">{{ database?.description }}</span>
    <small class="database-card__count">{{
        'emissionFactors.emissionFactor'
            | translatePlural: database?.count ?? 0
            | translate: { amount: database?.count }
    }}</small>
</div>
